module.exports = __webpack_public_path__ + "img/logo-light-nightskyfr.2b4e2925.png";